import React, { Component } from "react";
import ReactDOM from "react-dom";

import { Row, Tab, Tabs ,Alert} from "react-bootstrap";
import { Link } from "react-router-dom";
import CompareModels from "./CompareModels";
import LoadNewModelUi from "./LoadNewModelUi";

import ModelDetails from "./ModelDetails";

import SearchBar from "./widgets/SearchBar";
import SearchBarNew from "./widgets/SearchBarNew";

import BuildModelHead from "./widgets/BuildModelHead";

import ToolDesc from "./widgets/ToolDesc";
import { connect } from "react-redux";
import NomenclatureWizard from "./NomenclatureWizard";

class MatchModelsSearch extends Component {
  constructor(props) {
    super(props);
    this.details_ref = React.createRef();
    this.knowmore_ref = React.createRef();
    this.after_auto_complete_ref = React.createRef();
    this.after_auto_complete_search_ref = React.createRef();
    this.searchbar_ref = React.createRef();

    this.state = { selectedpage: "details", modeltoshow: "0", toggleOn: false };
   
  }
  setPage = page => {
    this.setState({ selectedpage: page });
    let elementTop = 0;
    if (page === "details") {
      this.scroll(this.knowmore_ref);
    }
    if (page === "knowmore") {
      this.scroll(this.details_ref);
    }
  };
  setModel = index => {
    this.setState({ modeltoshow: index });
  };
  scroll = ref => {
    if (ref.current) ref.current.scrollIntoView({ behavior: "smooth" });
  };
  scrollToError = () => {
    setTimeout(() => {
      if (this.searchbar_ref) this.scroll(this.searchbar_ref);
    }, 500);
  };

  // Callback function to handle toggle change
  handleToggleChange = (isToggled) => {
    this.setState({ toggleOn: isToggled });
  };

  render() {
    

    var fullui = <div ref={this.after_auto_complete_ref} />;
    if (
      typeof this.props.compare != "undefined" &&
      typeof this.props.compare.legacy != "undefined" &&
      typeof this.props.compare.a2l != "undefined" &&
      this.props.compare.a2l.length > 0
    ) {



        
      fullui = (
        <div
          ref={this.after_auto_complete_ref}
          className={"model_selected_" + this.state.modeltoshow}
        >
          <div className="Nav-area-final right">
            <div>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  window.print();
                }}
                className="btn print-btn"
              >
                <i className="fa fa-print" aria-hidden="true" />
                {"  Print"}
              </a>
            </div>
          </div>
          <div className="clear"></div>
          <Row className="printst print_tab">
            <Tabs defaultActiveKey="Model-Nomenclature">
              <Tab eventKey="Model-Nomenclature" title="Model Nomenclature">
                <ModelDetails setModel={this.setModel} modelIndex={this.state.modeltoshow} toggleOn={this.state.toggleOn} handleToggleChange={this.handleToggleChange}/>
              </Tab>
              <Tab
                eventKey="Compare-technical-Data"
                title="Compare Technical Data"
              >
                <CompareModels setModel={this.setModel} toggleOn={this.state.toggleOn} handleToggleChange={this.handleToggleChange}/>
              </Tab>
            </Tabs>
          </Row>
        </div>
      );
    }

    var searchui = <div ref={this.after_auto_complete_search_ref} />;
    var a2lrefCheck = this.props.autosuggest.value;
    let selectedRefrigerant = "R-448A"; // Default value

    if (a2lrefCheck.charAt(13) === "G") {
      selectedRefrigerant = "R-455A"; 
    }
    if (
      typeof this.props.compare != "undefined" &&
      typeof this.props.compare.newmodel != "undefined" &&
      typeof this.props.compare.newmodel.doe != "undefined" &&
      typeof this.props.compare.newmodel.nomenclature != "undefined"
    ) {
      searchui = (
        <div ref={this.after_auto_complete_search_ref}>
          <Row>
            <LoadNewModelUi 
              setModel={this.setModel} 
              selectedRefrigerant={selectedRefrigerant}
            />
          </Row>
        </div>
      );
    }
    return (
      <div className="Site">
        <div className="model-wrapper">
          <Row>
            <ToolDesc />
          </Row>
          <Row>
            <BuildModelHead
              page={this.state.selectedpage}
              setPage={this.setPage}
            />
          </Row>

          <div
            className=""
            ref={this.details_ref}
            style={{
              display: this.state.selectedpage === "details" ? "block" : "none"
            }}
          >
            <Tabs defaultActiveKey="Cross-Reference">
              <Tab
                eventKey="Cross-Reference"
                title="Cross-Reference"
                className="newcrossCompareTab"
              >
                <div className="cen_arrow mbtm10 print_disnone "></div>
                <h2 className="print_disnone">Cross-Reference</h2>
                <p className="print_disnone">
                  Enter your legacy model number to find an equivalent new model
                  option or options, standard features, and preferred option
                  packages. You can then click on Compare Technical Data to
                  compare legacy data with new model or models.
                </p>
                <h4 className="print_disnone">Legacy Model</h4>
                <p className="print_disnone">
                  Heatcraft condensing unit models utilizing nomenclature
                  methodology that was in effect up to the 3rd quarter of 2019.
                  Heatcraft evaporator/unit cooler models using nomenclature
                  methodology that is in effect up to the 1st quarter of 2020.
                </p>
                <h4 className="print_disnone">New Model</h4>
                <p className="print_disnone">
                  Heatcraft condensing unit models with new nomenclature
                  methodology launched on the 4th Quarter of 2019. Heatcraft
                  evaporator/unit cooler unit models with new nomenclature
                  methodology launching in the 2nd Quarter of 2020.
                </p>
                <h4 className="print_disnone">Application Capacity</h4>
                <p>Application Capacity is capacity associated with a nominal 10°F TD, 25°F/-20°F SST application condition historically established to successfully size equipment and components to satisfy a heat load, net of all influences, in an application.</p>
               

                <div ref={this.searchbar_ref}>
                  <SearchBar
                    setModel={this.setModel}
                    setPage={this.setPage}
                    redirect="false"
                    modelno={this.props.match.params.modelno}
                    scrollToError={this.scrollToError}
                  />
                </div>
                <div className="clear" />

                <div>{fullui}</div>
              </Tab>
              <Tab
                eventKey="Search-Model"
                title="Search New Model"
                className="newModelSearchTab"
              >
                <div className="cen_arrow mbtm10 print_disnone"></div>
                <h2 className="print_disnone">New Model Search</h2>

                <p className="print_disnone">
                Enter your new model number to determine if the model meets DOE minimum AWEF & to view technical data.
                </p>

                <div ref={this.searchbar_ref}>
                  <SearchBarNew
                    setPage={this.setPage}
                    redirect="false"
                    modelno={this.props.match.params.modelno}
                    scrollToError={this.scrollToError}
                  />
                </div>
                <div className="clear" />

                <div>{searchui}</div>
              </Tab>
            </Tabs>
          </div>
          <div
            className="seprate_div print_disnone"
            ref={this.knowmore_ref}
            style={{
              display: this.state.selectedpage === "knowmore" ? "block" : "none"
            }}
          >
            <div className="cen_arrow print_disnone" />
            <h2 className="print_disnone">Build a Heatcraft Model</h2>
            <p className="print_disnone">
              Quickly build a new model using the “Build a Heatcraft Model”
              tool. The tool will assist you in learning and understanding the
              new nomenclature structure.
            </p>
            <p>
              This is not a transactional tool. Visit{" "}
              <a target="blank" href="https://hub.heatcraftrpd.com/">
                THE HUB (https://hub.heatcraftrpd.com/)
              </a>{" "}
              to configure an actual new model and to build a quote.
            </p>
            <p className="boldredmessage">
              Build a Model for Unit Cooler/Evaporator is coming soon
            </p>

            <div className="clear" />
            <NomenclatureWizard />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
 
  return state;
}
export default connect(mapStateToProps)(MatchModelsSearch);
